<template>
  <transition @leave="leave">
    <a-plane material="shader: flat" width="8" height="8" color="#000" opacity="0">
      <a-image
        :src="cdn(require('./img/tooltip-' + lang + '.png'))"
        height=".5" :width=".5"
        ref="text"
        @materialtextureloaded="enter"
        opacity="0"
        shader="flat"
      />
    </a-plane>
  </transition>
</template>

<script>
export default {
  name: 'Tooltip',
  beforeDestroy() {
    this.$parent.viewed.tooltip = true
  },
  data: () => ({
    checkPos: [{
      ref: 'text',
      desktop: { x: -.25, y: .15, z: .001 },
      mobile: { x: -.07, y: .23, scale: .8 },
      landscape: { x: -.25, y: 0 },
    }]
  }),
  methods: {
    enter() {
      this.setDyniquePos()
      TweenLite.to(this.$el, 1, { aframe: { alpha: .3 } })
      TweenLite.to(this.$refs.text, 1, { aframe: { alpha: 1 } })
    },
    leave() {
      TweenLite.to([this.$el, this.$refs.text], 1, { aframe: { alpha: 0 } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tooltip/Tooltip.vue